import { useCallback } from "react"
import { useParams } from "react-router-dom"
import { Box, useTheme } from "@mui/material"

import { IContentWithAsideProps } from "layouts/kiosk-h/ContentWithAside"
import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"

import { useTranslation } from "providers/i18n"
import { useAppUI } from "providers/ui"
import { usePageSideBarLayout } from "providers/ui/hooks"

import { useEventDetail } from "hooks/event/useEventDetail"
import { useMobileUrl } from "hooks/useMobileUrl"

import { PageCard } from "components/card"
import { SidebarMenu } from "components/navigation/SidebarMenu"
import { DetailPage } from "components/domains/features/DetailPage"

interface IEventDetailKioskHPageProps {
  Layout?: React.FC<IContentWithAsideProps>
  AppNavigation?: React.ComponentType
}

export const EventDetailKioskHPage = ({
  Layout = Box,
  AppNavigation = DefaultAppNavigation,
}: IEventDetailKioskHPageProps) => {
  const { t } = useTranslation()

  const params = useParams()
  const { eventId } = params

  const { event, navigateToLocation } = useEventDetail(eventId)

  const { goBack } = useAppUI()

  const { mobileUrl } = useMobileUrl()

  usePageSideBarLayout({
    sidebar: {
      open: false,
    },
  })

  const theme = useTheme()

  const styleOverrides =
    theme.components[`EventDetailPage`]?.styleOverrides || {}
  const { root } = styleOverrides

  const handleClickBack = useCallback(() => {
    goBack()
  }, [goBack])

  if (!event) return null

  return (
    <>
      <Layout
        aside={
          <PageCard>
            <SidebarMenu AppNavigation={AppNavigation} />
          </PageCard>
        }
      >
        {event && (
          <DetailPage
            sx={root}
            item={event}
            headerDetail={t("Event Detail")}
            mobileUrl={mobileUrl}
            onBack={handleClickBack}
            onViewLocation={navigateToLocation}
          />
        )}
      </Layout>
    </>
  )
}
